import api from "../../config/client.axios.api";
import { TCreateUser } from "../../types";

export const createUserApiRequest = async (dataRequest: TCreateUser) => {
  const response = await api.post(`/account`, dataRequest);
  return response.data;
};
